import React, { JSX } from 'react';

import { ApiPackageDetails } from '@ibe/api';

import styled from '../../../../../Styles/theme';
import PackageDuration from '../PackageDuration/PackageDuration';
import Collapse from '../Collapse/Collapse';

const Container = styled.div(props => ({
  borderTop: `${props.theme.bootstrap.borderWidth} solid ${props.theme.bootstrap.gray400}`,
  borderLeft: 0,
  borderRight: 0,
  padding: '0.5rem 1rem',
  transition: 'background-color 300ms',
  '&:hover': {
    backgroundColor: props.theme.bootstrap.gray200
  }
}));

export interface PackageDurationsProps {
  durations: ApiPackageDetails[];
  onSelect: (duration: ApiPackageDetails) => void;
}

// TODO rename component to PackageDetailss

const PackageDurations = (props: PackageDurationsProps): JSX.Element => {
  const limit = 3;

  const { onSelect, durations } = props;

  durations.sort((d1, d2) => {
    if (d1.packageDurationInfo.duration === d2.packageDurationInfo.duration) {
      return 0;
    }
    return d1.packageDurationInfo.duration > d2.packageDurationInfo.duration ? 1 : -1;
  });

  const hasMore = durations.length > limit;
  const firstDurations = durations.slice(0, limit);
  const moreDurations = hasMore ? durations.slice(limit, durations.length) : [];

  return (
    <div>
      {firstDurations.map(duration => (
        <Container key={duration.id}>
          <PackageDuration duration={duration} onSelect={(d): void => onSelect(d)} />
        </Container>
      ))}

      {hasMore && (
        <Collapse textMore={`Show more (${moreDurations.length})`} textLess="Show less">
          {moreDurations.map(duration => (
            <Container key={duration.id}>
              <PackageDuration duration={duration} onSelect={(d): void => onSelect(d)} />
            </Container>
          ))}
        </Collapse>
      )}
    </div>
  );
};
export default PackageDurations;
